"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// ! Safari, firefox 뒤로가기/앞으로가기 브라우저 캐싱 방지
const react_1 = require("react");
function default_1() {
    const reloadOnPersist = (event) => {
        if (event.persisted) {
            location.reload();
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        window.addEventListener('pageshow', reloadOnPersist);
        return () => {
            window.removeEventListener('pageshow', reloadOnPersist);
        };
    }, []);
}
exports.default = default_1;
